
window.klaroConfig = {
  version: 2,
  styling: {
    theme: ['bottom'],
  },
  groupByPurpose: false,
  default: true,
  mustConsent: true,
  acceptAll: false,
  hideDeclineAll: false,
  hideLearnMore: false,
  noticeAsModal: false,
  required: false,

  // Example config that shows how to overwrite translations:
  // https://github.com/KIProtect/klaro/blob/master/src/configs/i18n.js
  translations: {
    en: {
      privacyPolicyUrl: '',
      consentModal: {
        title: 'External services we use',
        description: 'This page contains videos that are stored on Vimeo. You must agree to the use of this external content in order to view the videos.',
      },
      vimeo: {
        description: 'Videos hosted by Vimeo',
      },
    },
    de: {
      privacyPolicyUrl: '',
      consentModal: {
        title: 'Externe Dienste auf dieser Website',
        description: 'Diese Seite beinhaltet Videos, die bei Vimeo gespeichert sind. Sie müssen der Verwendung dieser externen Inhalte zustimmen, um die Videos sehen zu können.',
      },
      privacyPolicy: {
        name: 'Datenschutzerklärung',
        text: 'Detaillierte Informationen über die Verwendung von Cookies auf dieser Website finden Sie in unserer {privacyPolicy}.'
      },
      vimeo: {
        description: 'Videos gehostet von Vimeo',
      },
    },
  },

  services: [
    {
      name: 'vimeo',
    },
  ],
};
